import { __rest } from "tslib";
import React from 'react';
import { Transition } from 'react-transition-group';
const transitionDurationMs = 220;
const transitionTimingFunction = 'cubic-bezier(0.2, 0, 0, 1)';
const defaultTransitionProps = {
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true,
};
const TransitionHandler = (_a) => {
    var { component: Tag = 'div', in: inProp, onExited, defaultStyles, transitionStyles, transitionProps = defaultTransitionProps } = _a, props = __rest(_a, ["component", "in", "onExited", "defaultStyles", "transitionStyles", "transitionProps"]);
    const timeout = { enter: 0, exit: transitionDurationMs };
    return (React.createElement(Transition, Object.assign({ in: inProp, onExited: onExited, timeout: timeout }, transitionProps), (state) => {
        const style = Object.assign(Object.assign({}, defaultStyles), transitionStyles[state]);
        return React.createElement(Tag, Object.assign({ style: style }, props));
    }));
};
export const Slide = (_a) => {
    var { shouldUnmountOnExit = true, orient = 'left' } = _a, props = __rest(_a, ["shouldUnmountOnExit", "orient"]);
    return (React.createElement(TransitionHandler, Object.assign({ orient: orient, defaultStyles: {
            transition: `transform ${transitionDurationMs}ms ${transitionTimingFunction}, ` +
                `width ${transitionDurationMs}ms ${transitionTimingFunction}`,
            transform: orient === 'left' ? 'translate3d(-100%,0,0)' : 'translate3d(100%,0,0)',
        }, transitionStyles: {
            entered: { transform: null },
            exited: {
                transform: orient === 'left'
                    ? 'translate3d(-100%,0,0)'
                    : 'translate3d(100%,0,0)',
            },
        }, transitionProps: Object.assign(Object.assign({}, defaultTransitionProps), { unmountOnExit: shouldUnmountOnExit }) }, props)));
};
export const Fade = (_a) => {
    var { position } = _a, props = __rest(_a, ["position"]);
    return (React.createElement(TransitionHandler, Object.assign({ defaultStyles: {
            transition: `opacity ${transitionDurationMs}ms ${transitionTimingFunction}`,
            opacity: 0,
            position,
            zIndex: 1000,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
        }, transitionStyles: {
            entering: { opacity: 0 },
            entered: { opacity: 1 },
        } }, props)));
};
//# sourceMappingURL=Transitions.js.map